module.exports = __webpack_public_path__ + "img/yaxun-member-studio-v4.6872a660.png";